import type { FreeShippingCardContentProps, GiftContentResponse } from "./types"

export const freeShippingCardContent = ({
  currencySymbol,
  shippingThreshold,
}: FreeShippingCardContentProps): GiftContentResponse => {
  return {
    imageUrl:
      "/images/membership/discovery-journey/active-benefits/active-benefit-free-shipping.png",
    title: "Free Delivery",
    description:
      shippingThreshold !== null
        ? `Unlock FREE standard shipping when you spend over ${currencySymbol}${shippingThreshold}`
        : "",
  }
}
